import { Copy } from "lucide-react";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { copyToClipboard } from "../services/share";
import { Button } from "~/components/ui/button";
import { Input } from "~/components/ui/input";
import {
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "~/components/ui/dialog";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "~/components/ui/tooltip";

interface ShareModalProps {
  shareCode: string;
  shareUrl?: string;
  onClose?: () => void;
}

export function ShareModal({ shareCode, shareUrl, onClose }: ShareModalProps) {
  const { t } = useTranslation();
  const [showCopied, setShowCopied] = useState(false);

  const finalUrl =
    shareUrl?.replace("/t/", "/share/") ||
    `${
      typeof window !== "undefined"
        ? window.location.origin
        : "https://lotin.uz"
    }/share/${shareCode}`;

  const handleCopy = useCallback(async () => {
    const success = await copyToClipboard(finalUrl);
    if (success) {
      setShowCopied(true);
      setTimeout(() => setShowCopied(false), 2000);
    }
  }, [finalUrl]);

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("share.title")}</DialogTitle>
        <DialogDescription>{t("share.description")}</DialogDescription>
      </DialogHeader>
      <div className="flex gap-2 items-center">
        <Input
          type="text"
          readOnly
          value={finalUrl}
        />
        <Tooltip open={showCopied}>
          <TooltipTrigger asChild>
            <Button variant="ghost" size="icon" onClick={handleCopy}>
              <Copy />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t("share.copied")}</TooltipContent>
        </Tooltip>
      </div>
      <DialogDescription>{t("share.expirationNotice")}</DialogDescription>
    </DialogContent>
  );
}
